import { render } from "./date-type.vue?vue&type=template&id=6b978ef8"
import script from "./date-type.vue?vue&type=script&lang=js"
export * from "./date-type.vue?vue&type=script&lang=js"

import "./date-type.vue?vue&type=style&index=0&id=6b978ef8&lang=scss"

import exportComponent from "/Users/a/Documents/work/new/prnew/lk-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__